<script lang="ts" setup>
const props = defineProps({
  languages: {
    default: () => [],
    type: Array as PropType<CodingLanguage[]>,
  },
})

const { codingLanguages, getPreferredCodingLanguage, saveCodingLanguage } = useCoding()
const { t } = useI18n()
const route = useRoute()

const activeLanguage = computed(() => {
  return route.query.language || getPreferredCodingLanguage() || 'javascript'
})

const sortedLanguages = computed(() => {
  return props.languages.slice().sort((current, next) => {
    return current.localeCompare(next)
  })
})

function onClick(language: CodingLanguage) {
  saveCodingLanguage(language)
}
</script>

<template>
  <div class="mb-4 text-sm font-semibold text-gray-700 md:text-base dark:text-gray-300">
    {{ t('selectYourFavoriteLanguage') }}
  </div>

  <div class="flex flex-wrap items-center gap-3 md:grid md:grid-cols-2">
    <StepCard
      v-for="language in sortedLanguages"
      :key="language"
      :active="language === activeLanguage"
      :active-color="codingLanguages[language]?.color"
      clickable
      :icon="getIcon(language)"
      :title="t(`coding.languages.${language}`)"
      @click="onClick(language)"
    >
      <template #afterTitle>
        <UButton
          v-if="codingLanguages[language]?.sdk"
          class="ignore-step-style hidden md:flex"
          :icon="getIcon('download')"
          :label="t('sdk')"
          size="2xs"
          target="_blank"
          :to="codingLanguages[language]?.sdk"
          :ui="{ icon: { base: 'text-gray-600 dark:text-gray-400' } }"
          @click.stop
        />
      </template>
    </StepCard>
  </div>
</template>

<i18n lang="json">
{
  "en": {
    "sdk": "SDK",
    "selectYourFavoriteLanguage": "Select your favorite language:"
  },
  "es": {
    "sdk": "SDK",
    "selectYourFavoriteLanguage": "Selecciona tu lenguaje favorito:"
  },
  "fr": {
    "sdk": "SDK",
    "selectYourFavoriteLanguage": "Sélectionnez votre langage favori :"
  }
}
</i18n>
